import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#121722",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      opacity: ".4"
    }, [
      _createElementVNode("path", { d: "M9.583 18a7.917 7.917 0 1 0 0-15.833 7.917 7.917 0 0 0 0 15.833M18.333 18.834l-1.666-1.667" })
    ], -1)
  ]))]))
}
export default { render: render }